// extracted by mini-css-extract-plugin
module.exports = {"TableBody":"TableBody__1ylvl"};